import React from 'react'
import PropTypes from 'prop-types'
import { Provider } from 'react-redux'

import rootReducer from '../reducers'
import configureStore from 'Shared/configureStore'
import AddPublicHolidayContainer from './AddPublicHolidayContainer'


const AddPublicHolidayRoot = ({
  fetchInitialDataURL,
}) => {
  const state = {
    misc: {
      fetchInitialDataURL,
    },
  }

  const store = configureStore(rootReducer, state)

  return <Provider store={ store }><AddPublicHolidayContainer></AddPublicHolidayContainer></Provider>
}

AddPublicHolidayRoot.propTypes = {
  fetchInitialDataURL: PropTypes.string.isRequired,
}

export default AddPublicHolidayRoot
